import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Col = styled(Col)`
  margin-bottom: ${spacing('lg')};
`;
